import { DataBean } from "../../DataBean";


export class FingerType extends DataBean {

    public async getFingerprintTypes(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFingerprintTypes_Number", [args]);
    }

}